import type { ProductHit } from '@libs/algolia';
import { isLocaleCA, PharmacyType } from '@libs/core';

const isPrescriptionPharmacyType = (pharmacyType?: ProductHit['pharmacy-type']): boolean =>
    pharmacyType === PharmacyType.MED || pharmacyType === PharmacyType.FOOD;

type MerchantListingEligibilityInput = {
    isLivePet?: boolean;
    hasPharmacy?: boolean;
    isShipToHomeEligible: boolean;
};

export const isEligibleForMerchantListingSchema = ({
    isLivePet,
    hasPharmacy,
    isShipToHomeEligible,
}: MerchantListingEligibilityInput): boolean => isShipToHomeEligible && !isLivePet && !hasPharmacy;

const isProductHitShipToHomeEligible = (productHit: ProductHit): boolean => {
    const inStoreOnly = Boolean(productHit['shoppingOptions-isInStoreOnly']);
    const inStoreOnlyOverride = Boolean(productHit['shoppingOptions-isInStoreOnlyOverride']);
    const hasInStoreOnlyRestriction = inStoreOnly || inStoreOnlyOverride;
    const isCanadian = isLocaleCA();
    const shipToHomeEligibleCA = Boolean(productHit['shipToHome-isCASupported']);
    const isShipToHomeEligibleInRegion = !isCanadian || shipToHomeEligibleCA;

    return isShipToHomeEligibleInRegion && (!hasInStoreOnlyRestriction || isCanadian);
};

export const isProductHitEligibleForMerchantListingSchema = (productHit: ProductHit): boolean =>
    isEligibleForMerchantListingSchema({
        isLivePet: productHit.isLivePet,
        hasPharmacy: isPrescriptionPharmacyType(productHit['pharmacy-type']),
        isShipToHomeEligible: isProductHitShipToHomeEligible(productHit),
    });
